import React from "react";
import { StyledTableCell } from "../../../../styles/Shipmentstyles";
import {
  SxProps,
  TableCell,
  TableSortLabel,
  Theme,
  useTheme,
} from "@mui/material";
import { AppProperty } from "../../AppProperty";
import { SortType } from "../../../../models/SortType";

export interface AppTableRowCellProps {
  title?: string;
  sx?: SxProps<Theme>;
  textAlign?: AppProperty.TextAlign | undefined;
  fontSize?: string;
  minWidth?: string;
  sortColumn?: string;
  isSortActive?: boolean;
  sortDirection?: SortType;
  onSortChange?: (sortType: SortType) => void;
  children?: React.ReactNode;
  fontWeight?: number;
  color?: string;
  align?: "inherit" | "left" | "center" | "right" | "justify";
  onClick?: () => void;
}

const AppTableRowCell = ({
  title,
  sx,
  textAlign = "center",
  fontSize = "0.9rem",
  fontWeight = 600,
  color,
  align = "center",
  minWidth = "80px",
  sortColumn,
  isSortActive,
  sortDirection,
  onSortChange,
  children,
  onClick,
}: AppTableRowCellProps) => {
  const theme = useTheme<Theme>();

  const currentColor =
    color ||
    (theme.palette.mode === "dark" ? theme.palette.common.white : "#2A282E");

  const renderSortIcon = () => {
    return sortDirection === SortType.ASC ? "↑" : "↓";
    // return "↑↓";
  };

  return (
    <>
      {sx === undefined ? (
        <TableCell
          onClick={onClick}
          sx={{
            textAlign: textAlign,
            minWidth: { minWidth },
            fontSize: fontSize,
            fontWeight: fontWeight,
          }}
        >
          {onSortChange === undefined ||
          isSortActive === undefined ||
          sortDirection === undefined ? (
            children !== undefined && children !== null ? (
              children
            ) : (
              title
            )
          ) : (
            <TableSortLabel
              active={isSortActive}
              direction={sortDirection === SortType.ASC ? "asc" : "desc"}
              onClick={() =>
                onSortChange(
                  sortDirection === SortType.DESC
                    ? SortType.ASC
                    : SortType.DESC,
                )
              }
              IconComponent={() => <span>{renderSortIcon()}</span>}
              sx={{ fontSize: "0.8rem" }}
            >
              {children !== undefined && children !== null ? children : title}
            </TableSortLabel>
          )}
        </TableCell>
      ) : (
        <StyledTableCell
          onClick={onClick}
          sx={{
            textAlign: align,
            fontSize: fontSize,
            fontWeight: fontWeight,
            color: currentColor,
            ...sx,
          }}
        >
          {children !== undefined && children !== null ? children : title}
        </StyledTableCell>
      )}
    </>
  );
};

export default React.memo(AppTableRowCell);
